import React from 'react';
import { Shield, Upload } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';

const DNCListManagementCard = ({ productionStatus, onUploadDNC, executing }) => {
  return (
    <Card className="glass-card border-white/20">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Shield className="w-5 h-5 text-primary" />
          <div>
            <CardTitle>DNC List Management</CardTitle>
            <CardDescription className="mt-1">Upload and manage do-not-call list</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-3 gap-4">
          <div className="p-4 rounded-lg bg-secondary/50">
            <div className="text-2xl font-bold">{productionStatus?.compliance_stats?.dnc_count || 0}</div>
            <div className="text-xs text-muted-foreground mt-1">DNC Numbers</div>
          </div>
          <div className="p-4 rounded-lg bg-secondary/50">
            <div className="text-2xl font-bold text-destructive">{productionStatus?.compliance_stats?.blocked_today || 0}</div>
            <div className="text-xs text-muted-foreground mt-1">Blocked Today</div>
          </div>
          <div className="p-4 rounded-lg bg-secondary/50">
            <div className="text-2xl font-bold">{productionStatus?.compliance_stats?.total_checks_today || 0}</div>
            <div className="text-xs text-muted-foreground mt-1">Checks Today</div>
          </div>
        </div>

        <div className="p-4 rounded-lg border-2 border-dashed">
          <input
            type="file"
            accept=".csv"
            onChange={(e) => {
              if (e.target.files[0]) {
                onUploadDNC(e.target.files[0]);
              }
            }}
            className="hidden"
            id="dnc-upload"
            disabled={executing === 'dnc'}
          />
          <label htmlFor="dnc-upload" className="cursor-pointer">
            <div className="text-center">
              <Upload className="w-8 h-8 mx-auto mb-2 text-muted-foreground" />
              <p className="text-sm font-medium">Upload DNC List CSV</p>
              <p className="text-xs text-muted-foreground mt-1">
                Format: phone,source (e.g., +14031234567,manual)
              </p>
            </div>
          </label>
        </div>
      </CardContent>
    </Card>
  );
};

export default DNCListManagementCard;
